import { axios } from "../../cores/axiosWrapper";

export const getCustomContentsAPI = async (stageId, apiEndpoint, projectId, params) => {
    if (!(params?.createdFrom && params?.createdTo)) {
        delete params?.createdFrom;
        delete params?.createdTo;
    }
    if (!(params?.updatedFrom && params?.updatedTo)) {
        delete params?.updatedFrom;
        delete params?.updatedTo;
    }

    return axios.get(`${apiEndpoint}/v3/contents`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const createCustomContentAPI = async (apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/v3/contents`, data, {
        headers: {
            projectId,
        },
    });
};

export const deleteCustomContentAPI = async (apiEndpoint, projectId, contentId) => {
    return axios.delete(`${apiEndpoint}/v3/contents/${contentId}`, {
        headers: {
            projectId,
        },
    });
};
